import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YouTubePlayer from 'react-player/lib/players/YouTube';
import Modal from 'react-modal';
import FontIcon from 'components/FontIcon';
import { buildVideoStructuredData } from 'utils/StructuredData';
import classNames from 'classnames';
import { values, isEmpty } from 'lodash';
import VideoPlayerAClasses from './VideoPlayerA.module.scss';
import VideoPlayerBClasses from './VideoPlayerB.module.scss';

const {
  shape,
  string,
  bool,
} = PropTypes;

const videoPlayerClasses = {
  VideoPlayerA: VideoPlayerAClasses,
  VideoPlayerB: VideoPlayerBClasses,
};

class VideoPlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  closeModal() {
    this.setState({ isOpen: false });
  }

  render() {
    const { item = {}, cssClass = '', onCarousel = false, type = 'VideoPlayerA' } = this.props;
    const classes = videoPlayerClasses[type];

    const {
      videoImage = '',
      videoUrl = '',
      header = '',
      description = '',
      videoImageHeight,
      videoImageWidth,
    } = item;
    const { isOpen } = this.state;

    const image = (
      (type === 'VideoPlayerA' && videoImage &&
        <img
          className={classes.image2}
          src={videoImage}
          key='image'
          alt='VideoImage'
          width={videoImageWidth}
          height={videoImageHeight}
          loading='lazy'
          aria-hidden
        />
      )
    );

    const imageContainer = (
      (type === 'VideoPlayerA' && videoUrl &&
        <button
          className={classNames(classes.imageContainer, { [classes.individualImage]: !onCarousel })}
          onClick={this.openModal}
          key='image'
          aria-label='Play Video'
          type='button'
        >
          {image}
          <div className={classes.playIcon}>
            <FontIcon icon='far fa-play' />
          </div>
        </button>
      )
    );

    const headingContainer = (
      (header) &&
        <div
          className={classNames(classes.headingContainer, { [classes.onCarousel || '']: onCarousel })}
          key='heading'
          dangerouslySetInnerHTML={{ __html: header }}
        />
    );

    const descriptionContainer = (
      (description) &&
        <div
          className={classNames(classes.descriptionContainer, { [classes.onCarousel || '']: onCarousel })}
          key='description'
          dangerouslySetInnerHTML={{ __html: description }}
        />
    );

    const content = [headingContainer, imageContainer || image, descriptionContainer];
    const completeObject = values(item).every((val) => !isEmpty(val));

    return (
      <div
        className={classNames(
          { [classes.onCarouselContainer]: onCarousel, [classes.container]: !onCarousel },
          cssClass,
        )}
      >
        {completeObject && <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: buildVideoStructuredData(item) }}
        />}
        {content}
        <Modal
          isOpen={isOpen}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick
          ariaHideApp={false}
          className={classes.modal}
          overlayClassName={classes.overlayModal}
          closeTimeoutMS={250}
        >
          <span className={classes.close}>
            <button aria-label='Close' onClick={this.closeModal} className={classes.closeButton} type='button'>
              <FontIcon className={classes.icon} icon='far fa-times' />
            </button>
          </span>
          <YouTubePlayer
            url={videoUrl}
            width='100%'
            height={480}
            controls
            playing
          />
        </Modal>
      </div>
    );
  }
}

export const VideoPlayerT = shape({
  id: string,
  header: string,
  description: string,
  videoUrl: string,
  videoImage: string,
  uploadDate: string,
  videoImageHeight: PropTypes.number,
  videoImageWidth: PropTypes.number,
});

VideoPlayer.propTypes = {
  /**
   * Video Player Item Object
  */
  item: VideoPlayerT,
  /**
   * Custom css class applied
  */
  cssClass: string,
  /**
   * Display images in a carousel format<br>
   * Options: `true` `false`
  */
  onCarousel: bool,
  /**
   * Video Player Template<br>
   * Options: `VideoPlayerA`
  */
  type: string,
};

export default VideoPlayer;
